import React from 'react'
import { useLogout } from '../../../hooks/useLogout'
import { Link } from 'react-router-dom';

export const ModalSession = () => {
const logout = useLogout();

  return (
    <div className="modal-content contentWidhtSesion">

      <div className="modal-body ModalBodyStyleSesion">

        {/* <hr className="hr-session-top" data-bs-dismiss="modal" aria-label="Close"/>

          <div className="user-icon-session">
            <div className="circle-icon-container">
              <span className="material-symbols-outlined mI-session notranslate">account_circle</span>
            </div>

            <div className="user-data-session">
              <p className="session-name">Silvina Lambertini</p>
              <p className="session-email">silvinalambertini@gmail.com</p>
            </div>

          </div>

          <hr className="hr-session"/> */}

        <Link className="a-session " href="" onClick={logout}>
          <span className="material-symbols-outlined" aria-hidden="true" role="none">
            exit_to_app
          </span>
          <p>Cerrar Sesión</p>
        </Link>


      </div>

    </div>
  )
}
